<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="园区基础信息概况" name="first">
        <el-form
          label-position="right"
          label-width="180px"
          :model="basicsForm"
          :rules="basicsRules"
          ref="basicsForm"
        >
          <el-form-item label="销售面积" prop="deal_area">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="basicsForm.deal_area"
            ></el-input>
          </el-form-item>
          <el-form-item label="总面积" prop="all_area">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="basicsForm.all_area"
            ></el-input>
          </el-form-item>
          <el-form-item label="商写租赁面积" prop="business_lease_area">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="basicsForm.business_lease_area"
            ></el-input>
          </el-form-item>
          <el-form-item label="园区当前入驻企业数量" prop="company_nums">
            <!-- <el-input type="number" min="0" class="numInput" v-model="basicsForm.company_nums"></el-input> -->
            <el-input
              class="numInput"
              v-model.number="basicsForm.company_nums"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="出租率" prop="rental_rate">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="basicsForm.rental_rate"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="销售率" prop="sale_rate">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="basicsForm.sale_rate"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="入驻率" prop="settle_in_rate">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="basicsForm.settle_in_rate"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="总车位数" prop="park_place_nums">
            <!-- <el-input type="number"  min="0" class="numInput" v-model="basicsForm.park_place_nums"></el-input> -->
            <el-input
              class="numInput"
              v-model.number="basicsForm.park_place_nums"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="充电桩数量" prop="charging_station">
            <!-- <el-input type="number"  min="0" class="numInput" v-model="basicsForm.park_place_nums"></el-input> -->
            <el-input
              class="numInput"
              v-model.number="basicsForm.charging_station"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="infoSubmit('basicsForm')"
              >保存</el-button
            >
            <el-button @click="getInfo()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- <el-tab-pane label="重点项目宣传" name="second">
        <el-button size="small" type="primary" @click="ProjectAdd()"
          >添加</el-button
        >
        <el-table
          :data="projectData"
          border
          stripe
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="project_name" label="项目名称" width="180">
          </el-table-column>
          <el-table-column prop="name" label="状态" width="180">
            <template slot-scope="scope">
              {{
                scope.row.status == 0
                  ? "意向客户"
                  : scope.row.status == 1
                  ? "成交客户"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="flowup_person" label="跟进人">
          </el-table-column>
          <el-table-column prop="update_time" label="更新时间">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="210">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="warning"
                @click="projectSee(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="projectEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="projectDel(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="projectPage"
            :page-sizes="[15, 30, 50, 100]"
            :page-size="projectSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="projectTotal"
          >
          </el-pagination>
        </div>
      </el-tab-pane> -->
      <!-- <el-tab-pane label="园区能耗概况" name="third">
        <el-button size="small" type="primary" @click="energyAdd()"
          >添加</el-button
        >
        <el-table
          :data="energyData"
          border
          stripe
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="type" label="类型" width="180">
            <template slot-scope="scope">
              {{
                scope.row.type == "year"
                  ? "年"
                  : scope.row.type == "month"
                  ? "月"
                  : scope.row.type == "day"
                  ? "日"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="update_time" label="更新时间">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="210">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="warning"
                @click="energySee(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="energyEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="energyDel(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane> -->
    </el-tabs>
    <!-- 重点宣传 -->
    <!-- <el-dialog
      :title="projecTitle"
      :visible.sync="projecFormVisible"
      width="500px"
      @click="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="80px"
        :model="projecForm"
        ref="projecForm"
        :rules="projecRules"
      >
        <el-form-item label="项目名称" prop="project_name">
          <el-input
            v-model="projecForm.project_name"
            auto-complete="off"
            placeholder="请输入项目名称"
            :disabled="projecCz == 'see'"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group
            :disabled="projecCz == 'see'"
            v-model="projecForm.status"
          >
            <el-radio :label="0">意向客户</el-radio>
            <el-radio :label="1">成交客户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="跟进人" prop="flowup_person">
          <el-input
            :disabled="projecCz == 'see'"
            v-model="projecForm.flowup_person"
            auto-complete="off"
            placeholder="请输入跟进人"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          v-if="projecCz == 'add'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="projectAdd('projecForm')"
          >添加</el-button
        >
        <el-button
          v-if="projecCz == 'edit'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="projectTjEdit('projecForm')"
          >提交编辑</el-button
        >
      </div>
    </el-dialog> -->
    <!-- 能耗概况 -->
    <el-dialog
      :title="energyTitle"
      :visible.sync="energyFormVisible"
      width="500px"
      @click="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="80px"
        :model="energyForm"
        ref="energyForm"
        :rules="energyRules"
      >
        <el-form-item label="类型" prop="type">
          <el-radio-group
            :disabled="energyCz == 'see'"
            v-model="energyForm.type"
            @input="energyRadio"
          >
            <el-radio label="year">年</el-radio>
            <el-radio label="month">月</el-radio>
            <el-radio label="day">日</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="配置信息" prop="value">
          <div style="max-height: 300px; overflow: auto">
            <div
              style="display: flex"
              v-for="(item, index) in energyForm.value"
              :key="index"
            >
              <span
                >{{ index < 9 ? "0" + (index + 1) : index + 1
                }}{{
                  energyForm.type == "year"
                    ? "月"
                    : energyForm.type == "month"
                    ? "日"
                    : energyForm.type == "day"
                    ? "时"
                    : ""
                }}：</span
              >
              <el-input
                :disabled="energyCz == 'see'"
                size="small"
                v-model="item.electricity"
                auto-complete="off"
                placeholder="请输入总电能能耗"
                style="width: 150px"
                type="number"
                min="0"
                class="numInput"
              ></el-input>
              <el-input
                :disabled="energyCz == 'see'"
                size="small"
                v-model="item.water"
                auto-complete="off"
                placeholder="请输入总水能能耗"
                style="width: 150px"
                type="number"
                min="0"
                class="numInput"
              ></el-input>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          v-if="energyCz == 'add'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="energySubmit('energyForm')"
          >保存</el-button
        >
        <el-button
          v-if="energyCz == 'edit'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="energyTjEdit('energyForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  wcParkInfoEdit,
  wcParkInfoDetail,
  // wcZhProjectList,
  // wcZhProjectAdd,
  // wcZhProjectDel,
  // wcZhProjectEdit,
  // wcZhProjectDetail,
  wcZhEnergyList,
  wcZhEnergyDetail,
  wcZhEnergyDel,
  wcZhEnergyEdit,
  wcZhEnergyAdd,
} from "@/api/wuchang";
export default {
  components: {},
  data() {
    return {
      loading: false, //是显示加载
      activeName: "first",
      basicsForm: {
        deal_area: "",
        all_area: "",
        business_lease_area: "",
        company_nums: "",
        rental_rate: "",
        sale_rate: "",
        settle_in_rate: "",
        park_place_nums: "",
        charging_station:19
      },
      basicsRules: {
        deal_area: [
          { required: true, message: "请输入销售面积", trigger: "blur" },
        ],
        all_area: [
          { required: true, message: "请输入总面积", trigger: "blur" },
        ],
        business_lease_area: [
          { required: true, message: "请输入商写租赁面积", trigger: "blur" },
        ],
        company_nums: [
          {
            required: true,
            message: "请输入园区当前入驻企业数量",
            trigger: "blur",
          },
        ],
        rental_rate: [
          { required: true, message: "请输入出租率", trigger: "blur" },
        ],
        sale_rate: [
          { required: true, message: "请输入销售率", trigger: "blur" },
        ],
        settle_in_rate: [
          { required: true, message: "请输入入驻率", trigger: "blur" },
        ],
        park_place_nums: [
          { required: true, message: "请输入总车位数", trigger: "blur" },
        ],
      },
      projectData: [],
      projecTitle: "添加",
      projecCz: "add",
      projecFormVisible: false,
      projecForm: {},
      projecRules: {
        project_name: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        flowup_person: [
          { required: true, message: "请输入跟进人", trigger: "blur" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      // 能耗
      energyData: [],
      energyForm: {
        type: "",
        value: [],
      },
      energyFormVisible: false,
      energyTitle: "添加",
      energyCz: "",
      energyRules: {
        // type: [
        //   { required: true, message: "请输入项目名称", trigger: "blur" },
        // ],
        value: [{ required: true, message: "请输入配置信息", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      oldEnergyForm: {},
      projectPage: 1,
      projectTotal: 80,
      projectSize: 15,
    };
  },
  computed: {},
  mounted() {
    this.getInfo();
  },
  methods: {
    // 重点项目宣传-新增
    energySubmit(formName) {
      var that = this;
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            type: that.energyForm.type,
            value: JSON.stringify(that.energyForm.value),
          };
          wcZhEnergyAdd(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getEnergyList();
              that.energyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 能耗概括-编辑
    energyTjEdit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: that.energyForm.id,
            type: that.energyForm.type,
            value: JSON.stringify(that.energyForm.value),
          };
          wcZhEnergyEdit(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getEnergyList();
              that.energyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 能耗概括-删除
    energyDel(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          wcZhEnergyDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getEnergyList();
          });
        })
        .catch(() => {});
    },
    // 能耗概括-详情
    energyInfo(id) {
      wcZhEnergyDetail({ id: id }).then((res) => {
        this.energyForm = {
          id: res.data.id,
          type: res.data.type,
          value: JSON.parse(res.data.value),
        };
      });
    },
    // 添加能耗概括
    energyAdd() {
      this.energyFormVisible = true;
      this.energyTitle = "添加";
      this.energyCz = "add";
      this.energyForm = {
        type: "year",
        value: "",
      };
      this.energyRadio("year");
    },
    // 能耗概括-表格编辑操作
    energyEdit(val) {
      this.energyTitle = "编辑";
      this.energyCz = "edit";
      this.energyInfo(val.id);
      this.oldEnergyForm = {
        type: val.type,
        value: JSON.parse(val.value),
      };
      this.energyFormVisible = true;
    },
    // 能耗概括-表格查看操作
    energySee(val) {
      this.energyTitle = "查看";
      this.energyCz = "see";
      this.energyInfo(val.id);
      this.energyFormVisible = true;
    },
    // 能耗概括-列表
    getEnergyList() {
      wcZhEnergyList().then((res) => {
        this.energyData = res.data;
      });
    },
    // 获取重点项目宣传
    getProjectList() {
      let data = {
        page: this.projectPage,
        page_size: this.projectSize,
      };
      wcZhProjectList(data).then((res) => {
        this.projectTotal = res.data.total;
        this.projectData = res.data.data;
      });
    },
    // 重点项目分页
    handleSizeChange(val) {
      this.projectSize = val;
      this.getProjectList();
    },
    // 重点项目分页
    handleCurrentChange(val) {
      this.projectPage = val;
      this.getProjectList();
    },

    // 重点项目宣传-新增
    projectAdd(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          wcZhProjectAdd(that.projecForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getProjectList();
              that.projecFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 重点项目宣传-编辑
    projectTjEdit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          wcZhProjectEdit(that.projecForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getProjectList();
              that.projecFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 重点项目宣传-删除
    projectDel(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          wcZhProjectDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getProjectList();
          });
        })
        .catch(() => {});
    },
    // 重点项目宣传-详情
    projectInfo(id) {
      wcZhProjectDetail({ id: id }).then((res) => {
        this.projecForm = {
          project_name: res.data.project_name,
          status: res.data.status,
          flowup_person: res.data.flowup_person,
          id: res.data.id,
        };
      });
    },
    // 添加重点项目宣传
    ProjectAdd() {
      this.projecFormVisible = true;
      this.projecTitle = "添加";
      this.projecCz = "add";
      this.projecForm = {
        project_name: "",
        status: 0,
        flowup_person: "",
      };
    },
    // 表格编辑操作
    projectEdit(val) {
      this.projecTitle = "编辑";
      this.projecCz = "edit";
      this.projectInfo(val.id);
      this.projecFormVisible = true;
    },
    // 表格查看操作
    projectSee(val) {
      this.projecTitle = "查看";
      this.projecCz = "see";
      this.projectInfo(val.id);
      this.projecFormVisible = true;
    },
    // 获取基础信息
    getInfo() {
      wcParkInfoDetail().then((res) => {
        this.basicsForm = {
          deal_area: res.data.deal_area,
          all_area: res.data.all_area,
          business_lease_area: res.data.business_lease_area,
          company_nums: res.data.company_nums,
          rental_rate: res.data.rental_rate
            ? res.data.rental_rate.replace("%", "")
            : "",
          sale_rate: res.data.rental_rate
            ? res.data.sale_rate.replace("%", "")
            : "",
          settle_in_rate: res.data.rental_rate
            ? res.data.settle_in_rate.replace("%", "")
            : "",
          park_place_nums: res.data.park_place_nums,
          charging_station: res.data.charging_station
        };
      });
    },
    // 切换能耗类型
    energyRadio(e) {
      var that = this;
      that.energyForm.value = [];
      if (e == that.oldEnergyForm.type) {
        that.energyForm.value = that.oldEnergyForm.value;
      } else {
        if (e == "year") {
          for (var i = 0; i < 12; i++) {
            that.energyForm.value.push({
              water: "",
              electricity: "",
              time: i + 1,
              time_type: "M",
            });
          }
        } else if (e == "month") {
          let date = new Date();
          let year = date.getFullYear();
          let month = date.getMonth() + 1;
          let d = new Date(year, month, 0);
          for (var i = 0; i < d.getDate(); i++) {
            that.energyForm.value.push({
              time: i + 1,
              time_type: "D",
            });
          }
        } else if (e == "day") {
          for (var i = 0; i < 24; i++) {
            that.energyForm.value.push({
              time: i + 1,
              time_type: "H",
            });
          }
        }
      }
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.projecFormVisible = false;
      this.energyFormVisible = false;
    },
    // 园区基础信息概况提交
    infoSubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.basicsForm.rental_rate = this.basicsForm.rental_rate + "%";
          that.basicsForm.sale_rate = this.basicsForm.sale_rate + "%";
          that.basicsForm.settle_in_rate = this.basicsForm.settle_in_rate + "%";
          wcParkInfoEdit(that.basicsForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getInfo();
            }
          });
        } else {
          return false;
        }
      });
    },
    handleClick(tab, event) {
      if (tab.index == 0) {
        this.getInfo();
      } else if (tab.index == 1) {
        this.getEnergyList();
        // this.getProjectList();
      } 
      // else if (tab.index == 2) {
      //   this.getEnergyList();
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
}
.info {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
}

.box-card {
  width: 300px;
  height: 100px;
  display: inline-block;
  margin: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  text-align: center;
  line-height: 100px;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
